import { Injectable } from '@angular/core';
import { BrowserDetectionService } from './browserDetectionService';

@Injectable({
    providedIn: 'root'
})
export class FileDownloadService {
    constructor(private browserDetect: BrowserDetectionService) {}
    
    triggerDownload(blob: Blob, fileName: string) {
        if ((<any>window.navigator).msSaveOrOpenBlob) {
            this.triggerDownloadBlob(blob, fileName);
        } else {
            const objectUrl = (window.URL || window.webkitURL).createObjectURL(blob);
            console.debug('Downloading as object URL: ' + objectUrl);
            this.triggerDownloadLink(objectUrl, fileName);
        }
    }

    private triggerDownloadBlob(blob: Blob, name: string) {
        (<any>window.navigator).msSaveOrOpenBlob(blob, name);
    }

    public triggerDownloadLink(href: string, name: string) {
        const a = document.createElement('a');
        a.innerText = 'Download';
        a.title = 'Download';
        a.href = href;
        a.download = name;

        if (this.browserDetect.isSafari()) {
            const fileDownloader = window.open(href, '_blank');
            if (fileDownloader === undefined) {
                throw 'download_Error_Safari';
            }
            return;
        }

        document.body.appendChild(a);
        a.click();
        a.remove();
    }
}